import React from "react"
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

const PersonToggableButton = ({ 
  personIndex, 
  hasRental, 
  toggle,
  person 
}) => (
  <button onClick={toggle} type="button" className="sm:flex w-full text-left focus:outline-none">
    <div className="sm:w-4/5">
      <h2 className="mb-0 pr-4 truncate">
        {person.isBooker && !(person.firstName && person.lastName) 
          ? <FormattedMessage id="booking.person.yourName" defaultMessage="Your name" />
          : <> {(person.firstName && person.lastName)
            ? `${person.firstName} ${person.lastName}`
            : `Person ${personIndex + 1}`}
          </>
        }
      </h2>
      <div className="text-sm">
        {person.invite && (
          <div className="text-sm text-grey">
            Invitation will be sent
          </div>
        )}

        {(person.ageCategory || person.membership) && !person.invite && (
            person.ageCategory === 'adult' || (person.membership && person.membership.ageCategory) === 'adult'
              ? <FormattedMessage id='booking.person.adult' defaultMessage='Adult' />
              : <FormattedMessage id='booking.person.child' defaultMessage='Child' />
        )}
      </div>
    </div>

    {!person.invite && (
      <div className="hidden sm:block sm:w-1/5 truncate text-sm mt-2">
        <div className={`${hasRental ? 'font-bold' : 'text-grey'} truncate`}>
          <FormattedMessage id='booking.person.rentalEquipment' defaultMessage='Rental equipment' />
        </div>
        <div className={`${person.insuranceCancellation ? 'font-bold' : 'text-grey'} truncate sm:pt-2`}>
          <FormattedMessage id='booking.person.insuranceCancellation' defaultMessage='Insurance' />
        </div>
      </div>
    )}
  </button>
)

PersonToggableButton.propTypes = {
  personIndex: PropTypes.number.isRequired,
  hasRental: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  person: PropTypes.shape({
    person: PropTypes.object
  })
}

PersonToggableButton.defaultProps = {
  hasRental: false,
  person: {}
}

export default PersonToggableButton